import { jsx as _jsx } from "react/jsx-runtime";
import { useMediaQueryMatchesOnMobile } from '@yonderland/andes-react';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { Popover, PopoverType, usePopoverHandlers, POPOVER_ANIMATION_DURATION } from '@as/cotopaxi';
import { promoBasketPopupActions } from '../redux/promo-basket-popup/actions/PromoBasketPopupActions.creators';
import { makeGetPromoBasketPopupState } from '../redux/promo-basket-popup/selectors/PromoBasketPopupSelector';
import { makeGetProductDefaults } from '../redux/product/selectors/ProductSelector';
import PromoBasketPopupContentContainer from './PromoBasketPopupContentContainer';
import PromoBasketPopupCTAContainer from './PromoBasketPopupCTAContainer';
const PromoBasketPopupContainer = ({ dispatchInitializeAction, closePopup, popupState, productReady, }) => {
    const close = () => setTimeout(() => closePopup(), POPOVER_ANIMATION_DURATION);
    const { anchorEl, handlePopoverOpen, handlePopoverClose } = usePopoverHandlers({ close });
    const isMobile = useMediaQueryMatchesOnMobile();
    useEffect(() => {
        dispatchInitializeAction();
    }, []);
    useEffect(() => {
        if (!popupState.collapsed) {
            handlePopoverOpen(null, null, true);
        }
    }, [popupState.collapsed]);
    if (!productReady || popupState.collapsed)
        return null;
    return (_jsx(Popover, { disableClickOutside: true, anchorEl: anchorEl, type: PopoverType.MODAL, onClose: handlePopoverClose, title: popupState.message, footerElement: isMobile && _jsx(PromoBasketPopupCTAContainer, { closePopup: handlePopoverClose }), children: _jsx(PromoBasketPopupContentContainer, { closePopup: handlePopoverClose }) }));
};
const makeMapStateToProps = () => {
    const getPromoBasketPopupState = makeGetPromoBasketPopupState();
    const getProductDefaults = makeGetProductDefaults();
    const mapStateToProps = state => ({
        popupState: getPromoBasketPopupState(state),
        productReady: !!getProductDefaults(state).productCode,
    });
    return mapStateToProps;
};
const mapDispatchToProps = {
    closePopup: promoBasketPopupActions.createPopupCloseAction,
    dispatchInitializeAction: promoBasketPopupActions.createInitializeAction,
};
export default connect(makeMapStateToProps, mapDispatchToProps)(PromoBasketPopupContainer);
